<div class="col-sm-12 search-zone" *ngIf="!editTypeContenant && !addBon && !depuisDemande">
    <div class="container" style=" height: 100%">
        <div class="col-sm-12" style="padding: 0;">
            <div class="col-sm-2 col-md-2 col-lg-2" style="margin: 5px 0;">
                <app-filter-taille [defaultselected]="btnAffichage"
                    (selectfunction)="selectAffichage($event)"></app-filter-taille>
            </div>
            <div class="" style="padding: 0;"
                [ngClass]="{'col-sm-4': !common.isMajRetroBon, 'col-sm-3': common.isMajRetroBon}">
                <app-recherche-multiple [placeholder]="'Fournisseur ou article'" [minlength]="2" id="validationsearch"
                    [filtre]="searchTable" (selectfunction)="addFiltre($event)" [isclient]="true"
                    [afficherBonAFacturer]="!isHisto" [afficherBonHistorise]='isHisto' [type]="type"
                    (setdefaultfiltre)="common.setValueFiltre($event)"
                    [listeChoix]="returnListChoix()"></app-recherche-multiple>
            </div>

            <div class=" col-sm-2 btn-group text-center" dropdown #dropdown="bs-dropdown" [isOpen]="status.isopen"
                (isOpenChange)="change($event)" style="padding:4px 0;width: 13%;">
                <button type="submit" dropdownToggle class="bouton btn-filtre uppercase" [matBadge]="getNbrFiltres()"
                    matBadgeColor="primary" [matBadgeHidden]="!getNbrFiltres()"> Filtres
                    <i class="fa fa-chevron-down pull-right" aria-hidden="true"></i>
                </button>

                <!-- Propriétés -->
                <ul *dropdownMenu class="dropdown-menu filtre-bac-stock" role="menu">
                    <div class="col-sm-6" style="padding: 0;">
                        <li role="menuitem" dropdown #dropdown="bs-dropdown" placement="right" container="body">
                            <a class="dropdown-item title">
                                Propriétés
                            </a>
                        </li>
                        <li role="menuitem">
                            <a class="dropdown-item">
                                Par fournisseur
                                <input type="checkbox" id="checkbox-1-1 "
                                    class="regular-checkbox regular-checkbox-checked pull-right"
                                    [(ngModel)]="proprietes.parFournisseur" (change)="load('parFournisseur')">
                            </a>
                        </li>
                        <li role="menuitem">
                            <a class="dropdown-item">
                                Par type de contenant
                                <input type="checkbox" id="checkbox-1-1 "
                                    class="regular-checkbox regular-checkbox-checked pull-right"
                                    [(ngModel)]="proprietes.parTypeDeContenant" (change)="load('parTypeDeContenant')">
                            </a>
                        </li>
                        <li role="menuitem">
                            <a class="dropdown-item">
                                Par flux
                                <input type="checkbox" id="checkbox-1-1 "
                                    class="regular-checkbox regular-checkbox-checked pull-right"
                                    [(ngModel)]="proprietes.parFlux" (change)="load('parFlux')">
                            </a>
                        </li>
                    </div>

                    <div class="col-sm-6" style="padding: 0;">
                        <li role="menuitem" dropdown #dropdown="bs-dropdown" placement="right" container="body">
                            <a class="dropdown-item title">
                                Etats
                            </a>
                        </li>
                        <li role="menuitem" *ngFor="let item of etats">
                            <a class="dropdown-item">
                                {{ item.libelle }}
                                <input type="checkbox" id="checkbox-1-1 "
                                    class="regular-checkbox regular-checkbox-checked pull-right"
                                    [(ngModel)]="item.selected" (change)="load(item.libelle)">
                            </a>
                        </li>
                    </div>
                </ul>
            </div>

            <div class=" col-sm-2 btn-group text-center">
                <button class="btn-header uppercase" id="close" (click)="exportXLS()" style='margin-top: 5px'> Extraire
                    en XLS </button>
            </div>

            <div class="text-right col-sm-2 " dropdown style="padding: 4px 0px;">
                <button class="btn-header btn-facture uppercase" id="closeDemande" *ngIf="depuisDemande"
                    (click)="retourDemande()"> Fermer </button>
            </div>
        </div>
    </div>
</div>

<div class=" col-sm-12 " [ngClass]="{'contente-zone': !depuisDemande, 'contente-zonedmd': depuisDemande}"
    *ngIf="!editTypeContenant">
    <div class="tableau" [ngStyle]="{'padding': depuisDemande ? '0px' :'5px', 'height': '100%'}">
        <div class=" col-sm-12" [ngClass]="{'tete': !depuisDemande, 'teteDmd': depuisDemande}">
            <div class="col-sm-5" style="padding: 0px;">
                <h2 class="col-sm-12 text-left" style="padding:0px; margin: 0;"> </h2>
                <div class="col-sm-12" style="padding: 0;">
                    <span style="padding: 4px;"> </span>
                    <label class=" text-left uppercase text-underline"></label>
                </div>
            </div>
            <div class="col-sm-7">
                <h2 class="col-sm-12 text-right" style="padding:0px; margin: 0;">
                    <span *ngIf="!depuisDemande"> Gestion du stock du bac </span>
                    <span *ngIf="depuisDemande"> Stock des bacs </span>
                </h2>
                <!-- <div  class="col-sm-12 text-right" style="padding: 0;">
                    <label  class="uppercase text-underline historique">
                        <span > </span>
                    </label>
                </div> -->
            </div>
        </div>

        <div class=" col-sm-12 p-0" [ngClass]="{'tab': !depuisDemande, 'tabDmd': depuisDemande}">
            <ngx-datatable style="height: 100%;" #myTable class="material" [rows]="rows" [columnMode]="'force'"
                [headerHeight]="50" [rowHeight]="'auto'" [rowClass]="getRowClass"
                [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' : 'Pas de ligne à afficher'}"
                [loadingIndicator]="loadingIndicator" (activate)="onActivate($event)" (mouseleave)="mouseLeave($event)"
                [scrollbarH]="true">
                <ngx-datatable-column name="fournisseurToString" prop="fournisseurToString"
                    *ngIf="proprietes.parFournisseur" [width]="150">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader" (click)="sort()">
                            <span class="uppercase">Fournisseur</span>
                            <div class=" col-sm-1 pull-right">
                                <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                                <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="strong" (click)="showDetail(row)">
                            {{ value }}
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="typeContenantToString" prop="typeContenantToString"
                    *ngIf="proprietes.parTypeDeContenant" [width]="160">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader" (click)="sort()">
                            <span class="uppercase"> Type de contenant</span>
                            <div class=" col-sm-1 pull-right">
                                <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                                <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="strong" *ngIf="row.typeContenant && row.typeContenant.famille">
                            {{ value }}
                        </div>
                        <div class="strong"
                            *ngIf="!row.typeContenant || (row.typeContenant && ! row.typeContenant.famille)"> Non
                            renseigné </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="articleToString" prop="articleToString" *ngIf="proprietes.parFlux"
                    [width]="150">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader" (click)="sort()">
                            <span class="uppercase"> Article</span>
                            <div class=" col-sm-1 pull-right">
                                <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                                <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="strong"> {{ value }} </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="NonRenseigne" *ngFor="let item of etatsSelected; let i = index"
                    [width]="110">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> {{ item.libelle }} </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="strong" (click)="showDetail(row)"> {{ row.listDetailTotal[item.arrayIndex] }} </div>
                    </ng-template>
                </ngx-datatable-column>


                <ngx-datatable-column name="Prevu" [width]="100">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Prévu </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="strong" (click)="showDetail(row)"> {{ row.listDetailTotal[etats.length] }} </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="LivraisonPrevu" [width]="115">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Livraison prévue </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="strong" (click)="showDetail(row)"> {{ row.listDetailTotal[etats.length+1] }} </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Total" [width]="100">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Disponible </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="strong" (click)="showDetail(row)"> {{ row.listDetailTotal[1] -
                            row.listDetailTotal[etats.length] }} </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>
    </div>

    <!-- <div class="container" *ngIf="!showBon" style="padding-top: 10px;">
        <app-empty-table [title]="emptyTitle" [detail]="emptyDetail"></app-empty-table>
    </div> -->

</div>

<div class=" col-sm-12 contente-zone" *ngIf="editTypeContenant" style='height: calc(100% - 40px);'>
    <div class="tableau container">
        <div class="tab">
            <div class="col-sm-12 doc">
                <app-edit-param-contenant [contenant]="rowSelect || {}" [isAdd]="!rowSelect.id"
                    [parent]="'StockBacComponent'" (hidefunction)="showDetail()" [bacStock]="rowSelect"
                    [isFiltreFournisseur]="proprietes.parFournisseur"
                    [isFiltreTypeContenant]="proprietes.parTypeDeContenant" [isFiltreFlux]="proprietes.parFlux"
                    [listFiltreEtat]="etats"></app-edit-param-contenant>
            </div>
        </div>
    </div>
</div>

<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg" [innerHTML]="error"> </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
            </button>
        </div>
    </div>
</ng-template>